function Icon(param) {
  var { icons } = param;
  var _icons_web;
  return (_icons_web = icons.web) !== null && _icons_web !== void 0 ? _icons_web : null;
}
export {
  Icon
};
//# sourceMappingURL=Icon.js.map
